<template>
  <v-container></v-container>
</template>

<script>
export default {
  name: "QuantityConfirmShow"
}
</script>

<style scoped>

</style>
